import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useReisaanbiederData = () => {
  const [vacations, setVacations] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProvider, setSelectedProvider] = useState("all");
  const [priceFilter, setPriceFilter] = useState('all');
  const [providers, setProviders] = useState<string[]>([]);

  const fetchProviders = async () => {
    try {
      // Get ALL providers without filtering on imageURL/name since we only need provider names
      const { data, error } = await supabase
        .from('Complete feed')
        .select('aanbieder')
        .not('aanbieder', 'is', null)
        .not('aanbieder', 'eq', '');
      
      if (error) throw error;
      
      // Filter out empty strings and get unique providers
      const validProviders = data
        .map(item => item.aanbieder?.trim())
        .filter(provider => provider && provider.length > 0);
      
      const uniqueProviders = [...new Set(validProviders)].sort();
      console.log('Found unique providers:', uniqueProviders);
      setProviders(uniqueProviders);
    } catch (error: any) {
      console.error('Error fetching providers:', error);
    }
  };

  const fetchVacations = async () => {
    setLoading(true);
    try {
      let query = supabase
        .from('Complete feed')
        .select('*')
        .not('imageURL', 'is', null)
        .not('name', 'is', null)
        .not('aanbieder', 'is', null)
        .not('aanbieder', 'eq', '');

      if (searchTerm) {
        query = query.or(`name.ilike.%${searchTerm}%,description.ilike.%${searchTerm}%,city.ilike.%${searchTerm}%`);
      }

      if (selectedProvider !== "all") {
        query = query.eq('aanbieder', selectedProvider);
      }

      if (priceFilter === 'onbekend') {
        query = query.or('price.is.null,price.eq.0');
      } else if (priceFilter === '500') {
        query = query.gt('price', 0).lt('price', 500);
      } else if (priceFilter === '1000') {
        query = query.gte('price', 500).lt('price', 1000);
      } else if (priceFilter === '2000') {
        query = query.gte('price', 1000).lt('price', 2000);
      } else if (priceFilter === '3500') {
        query = query.gte('price', 2000).lt('price', 3500);
      } else if (priceFilter === '5000') {
        query = query.gte('price', 3500).lt('price', 5000);
      } else if (priceFilter === '5000+') {
        query = query.gte('price', 5000);
      }

      const { data, error } = await query.limit(100);
      
      if (error) throw error;
      
      // Shuffle the results randomly for variety
      const shuffledData = data ? [...data].sort(() => Math.random() - 0.5) : [];
      
      console.log('Reisaanbieder data loaded from Complete feed:', shuffledData?.length || 0, 'items');
      setVacations(shuffledData);
    } catch (error: any) {
      toast.error("Fout bij het laden van vakanties per reisaanbieder");
      console.error('Error fetching provider vacations:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProviders();
    fetchVacations();
  }, []);

  useEffect(() => {
    const delayedSearch = setTimeout(() => {
      fetchVacations();
    }, 300);

    return () => clearTimeout(delayedSearch);
  }, [searchTerm, selectedProvider, priceFilter]);

  return {
    vacations,
    loading,
    searchTerm,
    setSearchTerm,
    selectedProvider,
    setSelectedProvider,
    priceFilter,
    setPriceFilter,
    providers
  };
};
